const BLOG = {
  SET_BLOG_QUERY: 'SET_BLOG_QUERY',
};

export default BLOG;
